import React from 'react';

import { ContactSupport } from '@neptune/shared/common-ui';
import { Button } from '@neptune/shared/venus-ui';

export const ContactUs: React.FC = () => {
  return (
    <ContactSupport>
      <Button>Contact us</Button>
    </ContactSupport>
  );
};
